/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { GET_DATA } from '../../../../app/modules/auth/core/_requests'
import { imageendpoint } from '../../../../app/modules/auth/core/_requests'

const base = GET_DATA

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [actores, setListadoActores] = useState([]);
  
  useEffect(() => {
    const obtenerPersonajes = async ()=> {
      const url = base;
      const result = await axios.get(url)
      setListadoActores(result.data)
    }
    obtenerPersonajes()
  },[]);

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-auto'
      data-kt-menu='true'
    >
      {actores.length === 0 && <p>Cargando...</p>}
        {
          actores.map((personas, i)=>{
            return(
              <div className='menu-item px-3' key={i}>

                <div className='menu-content d-flex align-items-center px-3'>
                  <div className='symbol symbol-50px me-5'>
                  <img src={imageendpoint+personas['foto']} width="80px" height="80px"></img>
                  </div>

                  <div className='d-flex flex-column'>
                    <div className='fw-bolder d-flex align-items-center fs-5'>
                      {personas['firstname']}
                    </div>
                    <a href='mailto:' className='fw-bold text-muted text-hover-primary fs-7'>
                      {personas['email']}
                    </a>
                  </div>
                </div>

              <div className='separator my-2'></div>

              <div className='menu-item px-5'>
                <Link to={'/crafted/account/overview'} className='menu-link px-5'>
                  Mi perfil
                </Link>
              </div>

              <div className='separator my-2'></div>

              <div className='menu-item px-5 my-1'>
                <Link to='/crafted/account/settings' className='menu-link px-5'>
                  Configuración
                </Link>
              </div>

              <div className='menu-item px-5'>
                <a onClick={logout} className='menu-link px-5'>
                  Salir
                </a>
              </div>

            </div>
            )
          })
        }
    </div>
  )
}

export {HeaderUserMenu}